<h4>{{ 'reports.query-tool.set-sort-order.title' | translate | titlecase }}</h4>
<div class="mb-20">{{ 'reports.query-tool.set-sort-order.data-will-be-sorted-message' | translate | ucfirst }}</div>
<div class="mb-20" *ngIf="queryDefinition.SortExpressions != null">
  <p-table [showGridlines]="true" [value]="queryDefinition.SortExpressions" [rows]="queryDefinition.SortExpressions" [totalRecords]="queryDefinition.SortExpressions.length">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="w-60">
          {{ 'reports.query-tool.set-sort-order.field-name' | translate | titlecase }}
        </th>
        <th class="w-20">
          {{ 'reports.query-tool.set-sort-order.sort-direction' | translate | titlecase }}
        </th>
        <th class="w-10"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-sortingRule let-i="rowIndex">
      <tr>
        <td>
          <p-select [name]="'fieldName' + i" appendTo="body" [(ngModel)]="sortingRule.SortField"
            [options]="availableFields" optionLabel="ReplacementName" optionValue="ColumnName"
            [placeholder]="'common.select-dashes' | translate | titlecase" [style]="{ width: '100%' }"
            (onChange)="sortRuleChange()"></p-select>
        </td>
        <td>
          <p-select [name]="'sortOrder' + i" appendTo="body" [(ngModel)]="sortingRule.SortDirection"
            [options]="sortDirections" [placeholder]="'common.select-dashes' | translate | titlecase"
            [style]="{ width: '100%' }" (onChange)="sortRuleChange()"></p-select>
        </td>
        <td class="t-ac">
          <button pButton type="button" (click)="removeSortingRule(i)" class="atlas-btn atlas-btn-primary w-75">
            {{ 'common.remove' | translate | titlecase }}
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
<button pButton type="button" (click)="addSortingRule()" class="atlas-btn atlas-btn-primary">
  {{ 'reports.query-tool.set-sort-order.add-sorting-rule' | translate | titlecase }}
</button>